<template>
    <ul class="ps-0 mb-0 list-unstyled fw-medium mb-2 d-flex gap-3 flex-row flex-wrap align-items-center align-items">
        <li class="d-inline-block" v-for="link in links" :key="link">
            <a :href="$t(`footer_links.${link}.${env}`).trim().length === 0 ? undefined : $t(`footer_links.${link}.${env}`)" class="text-decoration-none text-body-secondary transition cursor-pointer" target="_blank">
                {{ $t(`page.footer_link.${link}`) }}
            </a>
        </li>
    </ul>
</template>

<script lang="ts">
import config, { Environment } from "@/utils/const/config";
import { CLIENT } from '@/utils/const/env';
import { defineComponent } from 'vue';




export default defineComponent({
    name: "FooterLinks",
    computed: {
        env(): Environment { return CLIENT },
        terms_link(): string {
            return this.$t('footer_links.terms_of_use');
        },
        privacy_link(): string {
            return this.$t('footer_links.privacy_policy');
        },
        cookie_link(): string {
            return this.$t('footer_links.cookie_policy');
        },
        links(): string[] {
            const env_links = config.footer_links;
            return env_links ?? [];
        }
    }

});
</script>